import React, { useState } from "react";
import { useRouter } from "next/router";
import { Button } from "components/button";
import { useNotify } from "hooks";
import { applyToSchool } from "services/school";
import { handleDateFormating } from "utils/date-formatter";
import {
   InvoiceTop,
   InvoiceWrapper,
   List,
   ListItem,
   ListItemHeader,
   InvoiceBody,
   FlexBtw,
} from "./styles";
import { Circles, SquareBoxes, Bubble } from "./vectors";

const InvoiceContainer = ({ school, payload }) => {
   const router = useRouter();
   const { notify } = useNotify();

   const [isLoading, setIsLoading] = useState(false);

   const handlePayment = async () => {
      try {
         const res = await applyToSchool(school.id, {
            ...payload,
            admissionFee: school.admissionFee,
            callbackUrl: `${window.location.href}?success="true"`,
         });
         router.push(res?.data?.data?.authorization_url);
      } catch (err: any) {
         notify({
            message: err.result.message || err.result.custom_message,
            variant: "error",
         });
      } finally {
         setIsLoading(false);
      }
   };
   const fee = 5000;
   return (
      <InvoiceWrapper>
         <InvoiceTop>
            <SquareBoxes />
            <Circles />
            <div style={{ color: "#fff" }}>
               <h1>Admission Application</h1>
               <h3>{school?.name}</h3>
               <p>{handleDateFormating(school?.date)}</p>
            </div>
         </InvoiceTop>

         <InvoiceBody>
            <FlexBtw>
               <List>
                  <ListItemHeader>Description</ListItemHeader>
                  <ListItem>Admission Application Fee</ListItem>
                  <ListItem>Edusko Service Fee</ListItem>
                  <ListItem style={{ fontWeight: 700 }}>Total</ListItem>
               </List>

               <List>
                  <ListItemHeader>Amount</ListItemHeader>
                  <ListItem>{school?.applicationFee}</ListItem>
                  <ListItem>{fee}</ListItem>
                  <ListItem style={{ fontWeight: 700 }}>
                     {Number(school?.applicationFee) + fee}
                  </ListItem>
               </List>
               <Bubble />
            </FlexBtw>

            <div style={{ display: "flex", justifyContent: "center", marginTop: 60 }}>
               <Button variant="primary" type="submit" disabled={isLoading} onClick={handlePayment}>
                  Make Payment
               </Button>
            </div>
         </InvoiceBody>
      </InvoiceWrapper>
   );
};

export default InvoiceContainer;
